<template>
    <div class="container">
        <b-modal :model-value="modDetReport" :no-close-on-backdrop="true" hide-header hide-footer centered>
            <!-- <pre>{{ infoDet }}</pre> -->
            <div class="text-center">
                {{ labels.title }} {{infoDet[0]?.nro_contrato}} 
            </div>
            <div>
                <b-row class="">
                    <b-table md-card md-header :items="infoDet">
                        <b-table-row slot="b-table-row" slot-scope="{ item }">
                            <b-table-cell :md-label="labels.fecha" class="border">{{ item?.fecha_cierre }}</b-table-cell> 
                            <b-table-cell :md-label="labels.actDerechUso" class="border">{{ Intl?.NumberFormat('es-CO',{ maximumFractionDigits: 3, minimumFractionDigits: 0}).format(item?.activo_derecho_uso_bruto) }}</b-table-cell> 
                            <b-table-cell :md-label="labels.amortAcumulada" class="border">{{ Intl?.NumberFormat('es-CO',{ maximumFractionDigits: 3, minimumFractionDigits: 0}).format(item?.amortizacion_acumulada) }}</b-table-cell> 
                            <b-table-cell :md-label="labels.pasivoFinal" class="border">{{ Intl?.NumberFormat('es-CO',{ maximumFractionDigits: 3, minimumFractionDigits: 0}).format(item?.pasivo_final) }}</b-table-cell> 
                            <b-table-cell :md-label="labels.patrimoNeto" class="border">{{ Intl?.NumberFormat('es-CO',{ maximumFractionDigits: 3, minimumFractionDigits: 0}).format(item?.patrimonio_neto) }}</b-table-cell> 
                            <b-table-cell :md-label="labels.pasivoInic" class="border">{{ Intl?.NumberFormat('es-CO',{ maximumFractionDigits: 3, minimumFractionDigits: 0}).format(item?.pasivo_inicial) }}</b-table-cell> 
                            <b-table-cell :md-label="labels.pagoCapital" class="border">{{ Intl?.NumberFormat('es-CO',{ maximumFractionDigits: 3, minimumFractionDigits: 0}).format(item?.pago_capital) }}</b-table-cell> 
                            <b-table-cell :md-label="labels.gastPorAmortiza" class="border">{{ Intl?.NumberFormat('es-CO',{ maximumFractionDigits: 3, minimumFractionDigits: 0}).format(item?.gasto_por_amortizacion) }}</b-table-cell> 
                            <b-table-cell :md-label="labels.gastPorIntereses" class="border">{{ Intl?.NumberFormat('es-CO',{ maximumFractionDigits: 3, minimumFractionDigits: 0}).format(item?.gasto_por_intereses) }}</b-table-cell> 
                            <b-table-cell :md-label="labels.gastPorArrendami" class="border">{{ Intl?.NumberFormat('es-CO',{ maximumFractionDigits: 3, minimumFractionDigits: 0}).format(item?.gasto_por_arrendamiento) }}</b-table-cell> 
                            <b-table-cell :md-label="labels.utilidadAcumulad" class="border">{{ Intl?.NumberFormat('es-CO',{ maximumFractionDigits: 3, minimumFractionDigits: 0}).format(item?.utilidades_acumuladas) }}</b-table-cell> 
                        </b-table-row>
                    </b-table>
                </b-row>
                <div class="mt-3">
                    <b-col class="text-right">
                        <b-button class="md-accent" @click="cierraModal">{{ labels.close }}</b-button> 
                    </b-col>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
export default {
    name : 'ModDetalleReporte',
    props : ['modDetReport','infoDet'],
    data : () => ({

    }),
    computed:{
        labels(){
            if(this.$store.state._language == "es-ES"){ 
                return {
                    title : 'Contrato',
                    close : 'Cerrar',
                    fecha : 'Fecha',
                    actDerechUso : 'Activo derecho uso',
                    amortAcumulada : 'Amortización acumulada',
                    pasivoFinal : 'Pasivo final',
                    patrimoNeto : 'Patrimonio neto',
                    pasivoInic : 'Pasivo inicial',
                    pagoCapital : 'Pago capital',
                    gastPorAmortiza : 'Gasto por amortización',
                    gastPorIntereses : 'Gasto por intereses',
                    gastPorArrendami : 'Gasto por arrendamiento',
                    utilidadAcumulad : 'Utilidades acumuladas'
                }
            }else{
                return {
                    title : 'Contract',
                    close : 'Close',
                    fecha : 'Date',
                    actDerechUso : 'Asset right use',
                    amortAcumulada : 'Accumulated amortization',
                    pasivoFinal : 'Final passive',
                    patrimoNeto : 'Net worth',
                    pasivoInic : 'Initial liabilities',
                    pagoCapital : 'Capital payment',
                    gastPorAmortiza : 'Amortization expense',
                    gastPorIntereses : 'Interest expense',
                    gastPorArrendami : 'Lease expense',
                    utilidadAcumulad : 'Retained earnings'
                }
            }
        }
    },
    methods:{
        cierraModal(){
            this.$emit('cierraModal',false) 
        },
    }
}
</script>

<style>

</style>
